module.exports = __webpack_public_path__ + "img/38.8ccb6164.jpg";